@if (!esDash) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @if (!tamanioGrande && breadcrumbs.length > 1) {
        <li class="breadcrumb-item color-gris" [matMenuTriggerFor]="menuBreadcrumb">...</li>
      }
      @if (!tamanioGrande) {
        <li class="breadcrumb-item" [routerLink]="'/'+concatenarRuta(breadcrumbs[breadcrumbs.length - 1].route)" queryParamsHandling="preserve" style="font-size:24px;">
          <a>{{ breadcrumbs[breadcrumbs.length - 1].label }}</a>
        </li>
      }
      @if (tamanioGrande) {
        @for (item of breadcrumbs; track item; let bi = $index) {
          <li class="breadcrumb-item" [ngClass]="{'active': item.activo}">
            <a [routerLink]="'/'+concatenarRuta(item.route)" style="font-size:24px;" queryParamsHandling="preserve" [ngClass]="{'color-gris': bi < breadcrumbs.length-1}">{{ item.label }}</a>
          </li>
        }
      }
    </ol>
    <mat-menu #menuBreadcrumb="matMenu">
      @for (item of breadcrumbs; track item; let bi = $index) {
        @if (bi < breadcrumbs.length-1) {
          <button mat-menu-item [routerLink]="'/'+concatenarRuta(item.route)" queryParamsHandling="preserve" >{{ item.label }}</button>
        }
      }
    </mat-menu>
  </nav>
}